import React from 'react'

import Icon from 'Pods/Shared/Icon/Icon'

function DropzoneOverlay() {
  return (
    <div className="drop-overlay">
      <Icon type={['fal', 'upload']} notSpaced /><br />
      Drop files here
    </div>
  )
}

export default DropzoneOverlay
